import { Base } from '@.api/methods';
import { AuthContextValue } from '@/Services';

import { AvailableClustersForUserFormResponse } from './response';

export class ServiceProviderClusterDictionaries extends Base {
    constructor(auth?: AuthContextValue | null) {
        super(auth, 'v2');
    }

    public availableClustersForUserForm(userId?: number) {
        this.setPath('dictionaries', 'sp-clusters', 'user-form');

        if (userId) {
            this.setQuery({ user_id: userId });
        }

        return this.getRequest<AvailableClustersForUserFormResponse>();
    }
}
